import {
  CREATE_SUBSCRIPTION_REQUEST,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_FAILURE,
  GET_SUBSCRIPTION_DETAILS_REQUEST,
  GET_SUBSCRIPTION_DETAILS_SUCCESS,
  GET_SUBSCRIPTION_DETAILS_FAILURE,
  GET_SUBSCRIPTION_HISTORY_REQUEST,
  GET_SUBSCRIPTION_HISTORY_SUCCESS,
  GET_SUBSCRIPTION_HISTORY_FAILURE,
  GET_SUBSCRIPTION_HISTORY_BY_ID_REQUEST,
  GET_SUBSCRIPTION_HISTORY_BY_ID_SUCCESS,
  GET_SUBSCRIPTION_HISTORY_BY_ID_FAILURE,
  GET_STATUS_FAILURE,
  GET_STATUS_REQUEST,
  GET_STATUS_SUCCESS,
  CLEAR_STATUS,
  CREATE_CUSTOMER_PORTAL_REQUEST,
  CREATE_CUSTOMER_PORTAL_FAILURE,
  CREATE_CUSTOMER_PORTAL_SUCCESS
} from "./subscriptionTypes";

const initialState = {
  subscription: null,
  loading: false,
  error: null,
  propertyCount: 0,
  subscriptionInfo: null,
  pricingTiers: null,
  subscriptionHistory: [],
  subscriptionHistoryById: [],
  status: null,
  trialStatus: null,
  userTrialDetails: null,
  detailsLoading: false,
  historyLoading: false,
  createLoading: false,
  portalLoading: false
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        createLoading: true,
        error: null
      };

    case GET_SUBSCRIPTION_DETAILS_REQUEST:
      return {
        ...state,
        detailsLoading: true,
        error: null
      };

    case GET_SUBSCRIPTION_HISTORY_REQUEST:
      return {
        ...state,
        historyLoading: true,
        error: null
      };

    case GET_SUBSCRIPTION_HISTORY_BY_ID_REQUEST:
      return {
        ...state,
        historyLoading: true,
        error: null
      };
    case GET_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        createLoading: false,
        subscription: action.payload.subscription,
        error: null
      };

    case GET_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        detailsLoading: false,
        subscription: action.payload.subscription,
        propertyCount: action.payload.propertyCount,
        subscriptionInfo: action.payload.subscriptionInfo,
        pricingTiers: action.payload.pricingTiers,
        trialStatus: action.payload.trialStatus,
        userTrialDetails: action.payload.userTrialDetails,
        error: null
      };

    case GET_SUBSCRIPTION_HISTORY_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        subscriptionHistory: action.payload.data,
        error: null
      };

    case GET_SUBSCRIPTION_HISTORY_BY_ID_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        subscriptionHistoryById: action.payload.data,
        error: null
      };
    case GET_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        status: action.payload,
        error: null
      };
    case CLEAR_STATUS:
      return {
        ...state,
        loading: false,
        status: null,
        error: null
      };
    case CREATE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        createLoading: false,
        error: action.error
      };

    case GET_SUBSCRIPTION_DETAILS_FAILURE:
      return {
        ...state,
        detailsLoading: false,
        error: action.error
      };

    case GET_SUBSCRIPTION_HISTORY_FAILURE:
    case GET_SUBSCRIPTION_HISTORY_BY_ID_FAILURE:
      return {
        ...state,
        historyLoading: false,
        error: action.error
      };

    case GET_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case CREATE_CUSTOMER_PORTAL_REQUEST:
      return {
        ...state,
        portalLoading: true,
        error: null
      };

    case CREATE_CUSTOMER_PORTAL_SUCCESS:
      return {
        ...state,
        portalLoading: false,
        error: null
      };

    case CREATE_CUSTOMER_PORTAL_FAILURE:
      return {
        ...state,
        portalLoading: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default subscriptionReducer;
